// export {localX as default}
// export {localX as exportedX};

const port = window.location.hostname;
// let host = ''
// console.log(port)
if (port === "coa.banwari.org") {
  exports.host = "https://coa.banwari.org";
} else if (port === "demo.banwari.org") {
  exports.host = "https://demo.banwari.org";
} else if (port === "localhost") {
  exports.host = "http://localhost:5568";
} else if (port === "62.72.31.157") {
  exports.host = "http://62.72.31.157:5568";
}

//  host = "http://157.245.99.110:5409"
//   host = "http://portal.eoais.com"
//  host = "http://localhost:5409";

// export default host

// console.log(port)
